// toggle cart drawer
const headerCartButton = document.querySelector("[data-header-cart-btn]");

if (headerCartButton) {
  headerCartButton.addEventListener("click", () => {
    const cartDrawer = document.querySelector("[data-cart-drawer-wrapper]");

    if (cartDrawer) {
      if (cartDrawer.dataset.cartDrawerWrapper === "close") {
        cartDrawer.dataset.cartDrawerWrapper = "open";
      }
    }
  })
}



// Search button
const searchButtons = document.querySelectorAll("[data-search-btn]");
searchButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const searchForm = button.closest("[data-search-wrapper]")
                              .querySelector("[data-search-form]");
    
    if (searchForm.dataset.searchForm === "close") {
      searchForm.dataset.searchForm = "open";
    } else {
      searchForm.dataset.searchForm = "close";
    }
  })
})

// close search form if clicked anywhere outside of input
const searchFormSurrounds = document.querySelectorAll("[data-search-form-surround]");

searchFormSurrounds.forEach((surround) => {
  surround.addEventListener("click", () => {
    const searchForm = surround.closest("[data-search-form]");

    if (searchForm.dataset.searchForm === "open") {
      searchForm.dataset.searchForm = "close";
    }
  })
})

// stop the previous close search form for the input element inside the form
const searchFormInputs = document.querySelectorAll("[data-search-form-input]");

searchFormInputs.forEach((input) => {
  input.addEventListener("click", (e) => {
    e.stopPropagation();
  })
})



// Header Language Form
const langButtons = document.querySelectorAll("[data-lang-form-btn]");

if (langButtons) {
  langButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const langForm = button.closest("[data-lang-form-wrapper]")
                             .querySelector("[data-lang-form]");
      if (langForm) {
        if (langForm.dataset.langForm === "close") {
          langForm.dataset.langForm = "open";
        }
      }
    })
  })
}



// Sort radio inpu checked attribute when Apply button clicked
/* const sortRadioInputs = document.querySelectorAll("[data-sort-radio]");
window.addEventListener("load", () => {
  const searchString = document.location.search;
  const searchParam = new URLSearchParams(searchString);
  const sortByParam = searchParam.get("sort-by");
  Shopify.queryParams.sort_by = sortByParam;
  for (const radio of sortRadioInputs) {
    if (radio.value == sortByParam) {
      radio.checked = true;
    }
  }
}) */



// About page The Brand & Media and Awards blogs toggle
const tabOneButton = document.querySelector('[data-tab-one-btn]');
const tabTwoButton = document.querySelector('[data-tab-two-btn]');

if (tabOneButton && tabTwoButton) {
  tabOneButton.addEventListener("click", () => {
    const tabOneContent = tabOneButton.closest("[data-tab-content]")
                                    .querySelector("[data-tab-one-content]");
    const tabTwoContent = tabOneButton.closest("[data-tab-content]")
                                    .querySelector("[data-tab-two-content]");
    if (tabOneContent.dataset.tabOneContent !== "active") {
      tabOneContent.dataset.tabOneContent = "active";
      tabOneButton.dataset.tabOneBtn = "active";
      tabTwoButton.dataset.tabTwoBtn = "inactive";
      tabTwoContent.dataset.tabTwoContent = "inactive";
    }
  })

  tabTwoButton.addEventListener("click", () => {
    const tabTwoContent = tabTwoButton.closest("[data-tab-content]")
                                    .querySelector("[data-tab-two-content]");
    const tabOneContent = tabOneButton.closest("[data-tab-content]")
                                    .querySelector("[data-tab-one-content]");
    if (tabTwoContent.dataset.tabTwoContent !== "active") {
      tabTwoContent.dataset.tabTwoContent = "active";
      tabTwoButton.dataset.tabTwoBtn = "active";
      tabOneButton.dataset.tabOneBtn = "inactive";
      tabOneContent.dataset.tabOneContent = "inactive";
    }
  })
}



// header dropdown
const headerDropdownButtons = document.querySelectorAll('.header-dropdown-button');
const headerDropdownMenus = document.querySelectorAll('.header-dropdown-menu');

headerDropdownButtons.forEach(button => {
  button.addEventListener('click', () => {
    const dropdown = button.closest('.header-dropdown');
    const dropdownMenu = dropdown.querySelector('.header-dropdown-menu')

    if (dropdownMenu.dataset.visibility === 'hidden') {
      headerDropdownMenus.forEach(menu => {
        menu.dataset.visibility = 'hidden';
      })
      dropdownMenu.dataset.visibility = 'show';
    } else {
      dropdownMenu.dataset.visibility = 'hidden';
    }
  })
})
